<div
  ngpCombobox
  class="wrapper"
  [class.is-disabled]="isDisabled()"
  [class.is-readonly]="readonly"
  [class.is-invalid]="errorState"
  [ngpComboboxValue]="comboValue"
  [ngpComboboxMultiple]="multiple"
  [ngpComboboxDisabled]="effectiveDisabled"
  [ngpComboboxCompareWith]="compareWith"
  [ngpComboboxDropdownContainer]="resolvedDropdownContainer"
  (ngpComboboxValueChange)="onValueChange($event)"
  [attr.aria-invalid]="errorState ? 'true' : null"
>
  <div class="field">
    @if (multiple) {
      @for (chip of visibleChips(); track chip) {
        <span class="chip">
          <span class="chip__label">{{ chip.label }}</span>
          <button
            type="button"
            class="chip__remove"
            tabindex="-1"
            [disabled]="effectiveDisabled"
            [attr.aria-label]="'Remove ' + chip.label"
            (click)="removeChip(chip.value, $event)"
          >
            <fa-icon [icon]="faXmark" />
          </button>
        </span>
      }
      @if (overflowCount() > 0) {
        <span class="chip chip--more">+{{ overflowCount() }} more</span>
      }
    }

    <input
      ngpComboboxInput
      class="input"
      type="text"
      autocomplete="off"
      [id]="effectiveId"
      [placeholder]="inputPlaceholder"
      [value]="query()"
      [readonly]="readonly"
      [disabled]="effectiveDisabled"
      (input)="onQueryInput($event)"
      (keydown)="onInputKeydown($event)"
      (click)="onInputClick()"
    />

    <!-- Committed value (single): a non-editable label over the empty search
      input. Hidden the moment the user types (query non-empty). -->
    @if (showSelectedValue()) {
      <span class="selected-value">{{ selectedLabel() }}</span>
    }
  </div>

  @if (loading) {
    <span class="spinner" aria-hidden="true"></span>
  }
  @if (!loading && clearable && !empty && !effectiveDisabled) {
    <button
      type="button"
      class="clear-btn"
      tabindex="-1"
      aria-label="Clear"
      (click)="clearAll($event)"
    >
      <fa-icon [icon]="faXmark" />
    </button>
  }

  <button
    type="button"
    ngpComboboxButton
    class="chevron-btn"
    [disabled]="effectiveDisabled"
  >
    <fa-icon [icon]="faChevronDown" />
  </button>

  <ng-template ngpComboboxPortal>
    <div ngpComboboxDropdown>
      @if (loading) {
        <span class="dropdown-msg">Loading…</span>
      }
      @if (!loading && showTypeToSearch) {
        <span class="dropdown-msg">{{ typeToSearchText }}</span>
      }
      @if (!loading && !showTypeToSearch) {
        @if (isGrouped()) {
          @for (group of groupedOptions(); track group.key) {
            @if (group.key) {
              <div class="option-group__header" aria-hidden="true">
                {{ group.key }}
              </div>
            }
            @for (opt of group.items; track opt.value) {
              <button
                type="button"
                ngpComboboxOption
                class="option"
                [ngpComboboxOptionValue]="opt.value"
                [ngpComboboxOptionDisabled]="opt.disabled ?? false"
                (mousedown)="$event.preventDefault()"
              >
                <span class="option__check" aria-hidden="true"></span>
                <span class="option__label">{{ opt.label }}</span>
              </button>
            }
          }
        } @else {
          @for (opt of filteredOptions(); track opt.value) {
            <button
              type="button"
              ngpComboboxOption
              class="option"
              [ngpComboboxOptionValue]="opt.value"
              [ngpComboboxOptionDisabled]="opt.disabled ?? false"
              (mousedown)="$event.preventDefault()"
            >
              <span class="option__check" aria-hidden="true"></span>
              <span class="option__label">{{ opt.label }}</span>
            </button>
          } @empty {
            <span class="dropdown-msg no-results">No results</span>
          }
        }
      }
    </div>
  </ng-template>
</div>
